import { createFileRoute, useParams } from "@tanstack/react-router";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import { TeamMemberDetailPage } from "@/components/supervisor/TeamMemberDetailPage";

export const Route = createFileRoute("/supervisor/_layout/team_/$id")({
  component: TeamMemberDetail,
});

function TeamMemberDetail() {
  const { id } = useParams({ from: "/supervisor/_layout/team_/$id" });
  return (
    <SidebarInset>
      <DashboardHeader current={"Detail"}
      />
      <div className="flex flex-col gap-4 p-6 pt-0">
        <TeamMemberDetailPage userId={id} />
      </div>
    </SidebarInset>
  );
}
